var GMapDesktop2016ModalView, GMapDesktop2016V2View, GMapView;

if (window.GMap == null) {
  window.GMap = {};
}

GMapView = require('./views/g_map');

GMapDesktop2016V2View = require('../desktop_2016/frontend/views/g_map');

GMapDesktop2016ModalView = require('../desktop_2016/frontend/views/g_map_modal.coffee');

GMap.init = function(arg, done) {
  var dynamicMaps, isDesktop2016V2, multipleLocations, staticMaps;
  dynamicMaps = arg.dynamicMaps, multipleLocations = arg.multipleLocations, staticMaps = arg.staticMaps, isDesktop2016V2 = arg.isDesktop2016V2;
  if (dynamicMaps == null) {
    return done();
  }
  if (isDesktop2016V2) {
    GMap.View = GMapDesktop2016V2View;
    GMap.ModalView = GMapDesktop2016ModalView;
  } else {
    GMap.View = GMapView;
  }
  return $(function() {
    var i, len, map;
    if (staticMaps != null ? staticMaps.shouldLazyLoadControls : void 0) {
      return DealContentLoader.addOnLoadHandler(function() {
        var i, len, map;
        for (i = 0, len = dynamicMaps.length; i < len; i++) {
          map = dynamicMaps[i];
          new GMap.View(_.extend(map, {
            staticMaps: staticMaps,
            isDesktop2016V2: isDesktop2016V2
          }));
        }
        return done();
      });
    } else {
      if (dynamicMaps[0].isDesktop2016V2) {
        new GMap.View(dynamicMaps[0]);
        if (dynamicMaps[1]) {
          new GMap.ModalView(dynamicMaps[1]);
        }
      } else {
        for (i = 0, len = dynamicMaps.length; i < len; i++) {
          map = dynamicMaps[i];
          new GMap.View(_.extend(map, {
            isDesktop2016V2: isDesktop2016V2
          }));
        }
      }
      return done();
    }
  });
};

module.exports = GMap;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9nX21hcC9mcm9udGVuZC9tYWluLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvZ19tYXAvZnJvbnRlbmQvbWFpbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7O0VBQUEsTUFBTSxDQUFDLE9BQVE7OztBQUVmLFFBQUEsR0FBVyxPQUFBLENBQVEsZUFBUjs7QUFDWCxxQkFBQSxHQUF3QixPQUFBLENBQVEsc0NBQVI7O0FBQ3hCLHdCQUFBLEdBQTJCLE9BQUEsQ0FBUSxtREFBUjs7QUFFM0IsSUFBSSxDQUFDLElBQUwsR0FBWSxTQUFDLEdBQUQsRUFBZ0UsSUFBaEU7QUFDVixNQUFBO0VBRFksK0JBQWEsMkNBQW1CLDZCQUFZO0VBQ3hELElBQXFCLG1CQUFyQjtBQUFBLFdBQU8sSUFBQSxDQUFBLEVBQVA7O0VBQ0EsSUFBRyxlQUFIO0lBQ0UsSUFBSSxDQUFDLElBQUwsR0FBWTtJQUNaLElBQUksQ0FBQyxTQUFMLEdBQWlCLHlCQUZuQjtHQUFBLE1BQUE7SUFJRSxJQUFJLENBQUMsSUFBTCxHQUFZLFNBSmQ7O1NBTUEsQ0FBQSxDQUFFLFNBQUE7QUFDQSxRQUFBO0lBQUEseUJBQUcsVUFBVSxDQUFFLCtCQUFmO2FBQ0UsaUJBQWlCLENBQUMsZ0JBQWxCLENBQW1DLFNBQUE7QUFDakMsWUFBQTtBQUFBLGFBQUEsNkNBQUE7O1VBQ0UsSUFBSSxJQUFJLENBQUMsSUFBVCxDQUFjLENBQUMsQ0FBQyxNQUFGLENBQVMsR0FBVCxFQUFjO1lBQUMsWUFBQSxVQUFEO1lBQWEsaUJBQUEsZUFBYjtXQUFkLENBQWQ7QUFERjtlQUVBLElBQUEsQ0FBQTtNQUhpQyxDQUFuQyxFQURGO0tBQUEsTUFBQTtNQU1FLElBQUcsV0FBWSxDQUFBLENBQUEsQ0FBRSxDQUFDLGVBQWxCO1FBQ0UsSUFBSSxJQUFJLENBQUMsSUFBVCxDQUFjLFdBQVksQ0FBQSxDQUFBLENBQTFCO1FBQ0EsSUFBRyxXQUFZLENBQUEsQ0FBQSxDQUFmO1VBQXVCLElBQUksSUFBSSxDQUFDLFNBQVQsQ0FBbUIsV0FBWSxDQUFBLENBQUEsQ0FBL0IsRUFBdkI7U0FGRjtPQUFBLE1BQUE7QUFJRSxhQUFBLDZDQUFBOztVQUNFLElBQUksSUFBSSxDQUFDLElBQVQsQ0FBYyxDQUFDLENBQUMsTUFBRixDQUFTLEdBQVQsRUFBYztZQUFDLGlCQUFBLGVBQUQ7V0FBZCxDQUFkO0FBREYsU0FKRjs7YUFPQSxJQUFBLENBQUEsRUFiRjs7RUFEQSxDQUFGO0FBUlU7O0FBd0JaLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
